/**
 * A24-style product-title auto-fit.
 *
 * A24's product titles are short (2–5 words) so they can sit at ~80px and the
 * price / quantity / add-to-cart still land above the fold. A keyword-stuffed
 * catalogue title at that size becomes a full-viewport wall of text that pushes
 * everything else off screen. This shrinks the title's font-size until it fits a
 * height budget (a fraction of the viewport), so short titles keep the big A24
 * treatment and long ones step down to something readable that still leaves the
 * buy controls visible on open.
 */
(function () {
  'use strict';

  var MIN_PX = 26;

  function fit(el) {
    // start from the stylesheet's responsive value, not a previous inline one
    el.style.fontSize = '';
    var start = parseFloat(getComputedStyle(el).fontSize) || 72;
    var budget = Math.min(460, Math.max(160, Math.round(window.innerHeight * 0.3)));

    if (el.scrollHeight <= budget) return; // short title — leave it alone

    var size = start;
    for (var i = 0; i < 80 && size > MIN_PX; i++) {
      size -= 2;
      el.style.fontSize = size + 'px';
      if (el.scrollHeight <= budget) break;
    }
  }

  function run() {
    document.querySelectorAll('.product__title h1, .product__title > h1').forEach(fit);
  }

  var raf;
  function onResize() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('resize', onResize, { passive: true });
  document.addEventListener('shopify:section:load', run);
  // fonts finish loading after first paint and change the measured height
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
})();
